import React from "react";
import { Divider, Grid, ListItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import dateFormat, { masks } from "dateformat";
import BlockIcon from '@mui/icons-material/Block';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box } from "@mui/system";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

function ERacunListItem(props) {
    
    const racun = props.racun;
    const grupa = props.grupa;
    
    return (
        <ListItem className={"list-item"} key={"racun" + racun.RacunID} style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: props.backColor }} onClick={(e) => props.onRacunClick(e, racun.RacunID, props.index, props.referenca.current)}>
            <Grid container>
                <Grid item xs={1}>
                    <Tooltip title={racun.Broj} enterDelay={200} enterNextDelay={200}>
                        <ListItemText style={{ paddingLeft:"5px" }} primaryTypographyProps={{ noWrap:true, fontWeight:props.fontWeight }} primary={ racun.Broj } />
                    </Tooltip>
                </Grid>
                {grupa == 0 ? (
                    <Grid item xs={2}>
                        <Tooltip title={dateFormat(racun.Datum, "dd.mm.yyyy")} enterDelay={200} enterNextDelay={200}>
                            <ListItemText style={{ paddingLeft:"15px" }} primaryTypographyProps={{ noWrap:true, fontWeight:props.fontWeight }} primary={ dateFormat(racun.Datum, "dd.mm.yyyy") } />
                        </Tooltip>
                    </Grid>
                ) : null}
                <Grid item xs={1}>
                    <Tooltip title={racun.Iznos.toLocaleString("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} enterDelay={200} enterNextDelay={200}>
                        <ListItemText style={{ paddingLeft:"5px" }} primaryTypographyProps={{ noWrap:true, fontWeight:props.fontWeight, textAlign:"right" }} primary={ racun.Iznos.toLocaleString("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) } />
                    </Tooltip>
                </Grid>
                <Grid item xs={3}>
                    <Tooltip title={racun.Klijent} enterDelay={200} enterNextDelay={200}>
                        <ListItemText style={{ paddingLeft:"15px" }} primaryTypographyProps={{ noWrap:true, fontWeight:props.fontWeight }} primary={ racun.Klijent } />
                    </Tooltip>
                </Grid>
                <Grid item xs={5} container>
                    <Tooltip 
                        title={racun.Errors && racun.Errors.length > 0 ? (<span dangerouslySetInnerHTML={{__html:racun.Errors.join("<br />")}}></span>) : racun.Status} 
                        enterDelay={200} 
                        enterNextDelay={200}
                    >
                        <ListItemText 
                            style={{ paddingLeft:"15px" }} 
                            primaryTypographyProps={{ noWrap:true, fontWeight:props.fontWeight }} 
                            primary={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {racun.StatusID == 7 ? (
                                        <BlockIcon fontSize="small" color="error" />
                                    ) : null}
                                    {racun.StatusID == 8 ? (
                                        <ErrorOutlineIcon fontSize="small" color="error" />
                                    ) : null}
                                    {racun.StatusID == 9 ? (
                                        <WarningAmberIcon fontSize="small" color="warning" />
                                    ) : null}
                                    {racun.Errors && racun.Errors.length > 0 ? racun.Errors[0] : racun.Status}
                                    {racun.Errors && racun.Errors.length > 1 ? <MoreHorizIcon fontSize="small" /> : null}
                                </Box>
                            }
                        />
                    </Tooltip>
                </Grid>
                {grupa == 3 ? (
                    <Grid item xs={2}>
                        <Tooltip title={dateFormat(racun.DatumSlanja, "dd.mm.yyyy HH:MM")} enterDelay={200} enterNextDelay={200}>
                            <ListItemText style={{ paddingLeft:"15px" }} primaryTypographyProps={{ noWrap:true, fontWeight:props.fontWeight }} primary={ dateFormat(racun.DatumSlanja, "dd.mm.yyyy HH:MM") } />
                        </Tooltip>
                    </Grid>
                ) : null}
                {!props.isLast ? (
                    <Grid item xs={12}>
                        <Divider></Divider>
                    </Grid>
                ) : null}
            </Grid>
        </ListItem>
    );
}

export default React.memo(ERacunListItem, (oldProps, newProps) => {
    return oldProps.fontWeight === newProps.fontWeight
        && oldProps.racun.Loaded === newProps.racun.Loaded 
        && oldProps.isLast === newProps.isLast
        && oldProps.grupa == newProps.grupa
});